import React, { PureComponent } from 'react'
import Slider from 'rc-slider';
import cx from 'classnames'
import ToolTipHandle from './ToolTipHandle';



export default class ReadProgress extends PureComponent {
  state = {
    seekValue: 0,
    seeking: false
  }

  static getDerivedStateFromProps(props, state) {
    if (!state.seeking) {
      return {
        ...state,
        seekValue: props.activeFrame
      }
    } else {
      return state;
    }
  }

  onSeekMouseDown = () => {
    this.setState({ seeking: true })
  };

  handleSeekChange = frame => {
    const {
      availableNumberOfFrames
    } = this.props;
    const seekValue = frame < availableNumberOfFrames ? frame : availableNumberOfFrames;
    this.setState({
      seekValue,
      nextFrame: seekValue
    });
  };

  onSeekMouseUp = () => {
    if (this.state.nextFrame !== this.props.activeFrame) {
      this.props.setFrameToView(this.state.nextFrame + 1);
    }
    this.setState({ seeking: false });
  };


  render() {
    const { max, tooltipVisibility, isVisible } = this.props;
    return (

      <Slider
        className="cnb-text-player-frame-control"
        min={0}
        max={max}
        step={1}
        value={this.state.seekValue}
        onBeforeChange={this.onSeekMouseDown}
        onChange={this.handleSeekChange}
        onAfterChange={this.onSeekMouseUp}
        // handle={(props) => console.log(props)}
        handle={({ ref, ...props }) => <ToolTipHandle {...props} visible={tooltipVisibility} />}
      />

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ReadProgress.jsx